const TEMPERATURE = 'temperature'
const HUMIDITY = 'humidity'
const CO2 = 'co2'
const FORMALDEHYDE = 'formaldehyde'
const VOCS = 'vocs'
const VOCS_INDEX = 'vocsIndex'
const PM1 = 'pm1'
const PM4 = 'pm4'
const PM10 = 'pm10'
const PM25 = 'pm25'
const CO = 'co'
const O3 = 'o3'
const NO2 = 'no2'
const LIGHT = 'lux'
const NOISE = 'dB'

const RADIANT_TEMPERATURE = 'radiantTemperature'
const NOX = 'nox'
const CAPACITY = 'capacity'
const NH3 = 'nh3'
const NO = 'no'
const SO2 = 'so2'
const RADON = 'radon'

const WEATHER = 'weather'
const OUTDOOR_AIR_QUALITY = 'outdoorAirQuality'

const THERMAL_INDICATOR = 'thermalIndicator'
const MOLD_INDICATOR = 'moldIndicator'
const COVID_19 = 'covid19'
const IAQ = 'iaq'
const VENTILATION_INDICATOR = 'ventilationIndicator'
const GO_IAQS = 'goIaqsIndicator'
const GO_IAQS_DOMINANT = 'goIaqsDominant'

// Types that exist only to support another data point
export const AUXILIARY_TYPES = new Set([GO_IAQS_DOMINANT])

export default {
  TEMPERATURE,
  HUMIDITY,
  CO2,
  FORMALDEHYDE,
  VOCS,
  VOCS_INDEX,
  PM1,
  PM4,
  PM10,
  PM25,
  CO,
  O3,
  NO2,
  LIGHT,
  NOISE,

  RADIANT_TEMPERATURE,
  RADON,
  NOX,
  CAPACITY,
  NH3,
  SO2,
  NO,

  THERMAL_INDICATOR,
  MOLD_INDICATOR,
  COVID_19,
  IAQ,
  VENTILATION_INDICATOR,
  GO_IAQS,
  GO_IAQS_DOMINANT,

  WEATHER,
  OUTDOOR_AIR_QUALITY
}
